



























































































































































































import Vue from "vue";
import moment from "moment";

// Vue Components
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import MachineModelFilter from "@/components/TableHeaderFilters/MachineModelFilter.vue";
import EcrStatusFilter from "@/components/TableHeaderFilters/EcrStatusFilter.vue";
import EcrCodeFilter from "@/components/TableHeaderFilters/EcrCodeFilter.vue";
import SensorModelFilter from "@/components/TableHeaderFilters/SensorModelFilter.vue";
import SensorFirmwareFilter from "@/components/TableHeaderFilters/SensorFirmwareFilter.vue";
import EcrDeviceCategoryFilter from "@/components/TableHeaderFilters/EcrDeviceCategoryFilter.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { ecrCodeStatusEnumLabel, EcrCodeStatusEnum } from "@/model/data/ecr/EcrCodeStatusEnum";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { VersionObfuscator } from "@/model/data/updates/VersionObfuscator";

export default Vue.extend({
    components: {
        DeviceModelChip,
        TableFiltersRow,
        ColumnVisibilityFilter,
    },
    data() {
        return {
            moment,
            VersionObfuscator,
            dataTableItemsPerPage,
            BranchFilter,
            MachineModelFilter,
            EcrCodeStatusEnum,
            UpdateTypeEnum,
            options: {},
            ignoreOptionsChanges: false,
            availableHeaders: [],
            initialAvailableHeaders: [
                {
                    enabled: true,
                    text: this.$t("common.installationName"),
                    value: "name",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("common.branch"),
                    value: "branch.name",
                },
                {
                    enabled: true,
                    text: this.$t("common.tags"),
                    value: "tags",
                },
                {
                    enabled: false,
                    text: this.$t("common.pcName"),
                    value: "connectedPc",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: "",
                    value: "divider",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("common.device/s"),
                    value: "machines",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("ecrCodes.ecrStatus"),
                    value: "ecrStatus",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("ecrCodes.ecrCode"),
                    value: "ecrCode",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("ecrCodes.certModel"),
                    value: "certModel",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("ecrCodes.ecrParentCode"),
                    value: "ecrParentCode",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("ecrCodes.sensorHw"),
                    value: "sensorHw",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("ecrCodes.sensorSw"),
                    value: "sensorSw",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("ecrCodes.deviceCategory"),
                    value: "deviceCategory",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("ecrCodes.testDate"),
                    value: "testDate",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("ecrCodes.expirationDate"),
                    value: "expirationDate",
                    sortable: false,
                },
            ],
            filters: [
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "machines",
                    filterKey: "machineModels",
                    component: MachineModelFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "ecrStatus",
                    filterKey: "ecrCodeStatus",
                    component: EcrStatusFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "ecrCode",
                    filterKey: "ecrCodes",
                    component: EcrCodeFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "sensorHw",
                    filterKey: "sensorModels",
                    component: SensorModelFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "sensorSw",
                    filterKey: "sensorFirmwares",
                    component: SensorFirmwareFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "deviceCategory",
                    filterKey: "devicesCategories",
                    component: EcrDeviceCategoryFilter,
                    currentSelections: [],
                },
            ],
        };
    },
    props: {
        loading: Boolean,
        installations: Array,
        reqData: Object,
        paginatedTotalItems: Number,
        currentPaginationOptions: Object,
    },
    watch: {
        options: {
            handler(newOptions) {
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
    },
    methods: {
        ecrCodeStatusEnumLabel,

        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },

        async exportAs(exportType) {
            this.$emit("download", exportType);
        },
    },
});
